import { render, staticRenderFns } from "./editdashboard.vue?vue&type=template&id=776b9cd6&scoped=true"
import script from "./editdashboard.vue?vue&type=script&lang=js"
export * from "./editdashboard.vue?vue&type=script&lang=js"
import style0 from "./editdashboard.vue?vue&type=style&index=0&id=776b9cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b9cd6",
  null
  
)

export default component.exports